import { inject, Injectable } from '@angular/core';
import { useDeviceStore } from '@ottobock/remote-update/domain';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetailsService {
  private deviceStore = inject(useDeviceStore);

  getDeviceDetails(deviceId: number) {
    return this.deviceStore.loadDeviceDetails(deviceId);
  }
}
